/* eslint-disable @typescript-eslint/naming-convention */

const chaptersCommon = import("../../components");

export const StoryParagraphs = {
    block_text: () => chaptersCommon.then((m) => m.BlockTextComponentModule),
    block_standard_media: () => chaptersCommon.then((m) => m.BlockMediaModule),
    block_hero_media: () => chaptersCommon.then((m) => m.BlockMediaModule),
    block_full_hero_media: () => chaptersCommon.then((m) => m.BlockMediaModule),
    block_media_text: () => chaptersCommon.then((m) => m.BlockMediaTextModule),
    block_duo_media: () => chaptersCommon.then((m) => m.BlockDuoMediaModule),
    block_youtube: () => chaptersCommon.then((m) => m.BlockYoutubeModule),
    block_event_booking: () => chaptersCommon.then((m) => m.BookingEventModule),
    gallery_carousel: () => chaptersCommon.then((m) => m.GalleryCarouselModule),
    live_stream: () => chaptersCommon.then((m) => m.LivestreamModule),
    push_podcast: () => chaptersCommon.then((m) => m.PodcastModule),
    push_category_poster: () =>
        chaptersCommon.then((m) => m.CategoryPosterModule),
    push_editorial_selection: () =>
        chaptersCommon.then((m) => m.EditorialSelectionModule),
    block_text_on_full_hero_media: () =>
        chaptersCommon.then((m) => m.BlockTextOnFullMediaModule),
    push_merchandising: () => chaptersCommon.then((m) => m.PushMerchModule),
} as const;
